export default __webpack_public_path__ + "static/media/iconEvent.346efa83.png";